import { render, staticRenderFns } from "./editform.vue?vue&type=template&id=06648060&scoped=true"
import script from "./editform.vue?vue&type=script&lang=js"
export * from "./editform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06648060",
  null
  
)

export default component.exports